export default __webpack_public_path__ + "static/favicon-b5b70ab76043572e38ad47c0a327d837.png";